export default __webpack_public_path__ + "assets/images/b49a00f948fdb73a36d8fa1ced0d4267.png";